import React, { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSimpleRegisterMutation } from "../../../../store/authentication/authService";
import { InputsRules } from "../../../../constants/auth";
import { authErrorMessages } from "../../../../utils";
import { setNotification } from "../../../../store/wizardCreate/wizardCreateSlice";
import { setRegistration } from "../../../../store/authentication/authSlice";

import AuthTitle from "../AuthTitle";
import AuthInput from "../AuthInput";
import AuthSocial from "../AuthSocial";
import AuthRegistrationFooter from "../AuthRegistrationFooter";

import { Container, DisabledInput, Link } from "./styles";

const AuthRegistration = ({ changeTab }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    handleSubmit,
    control,
    setError,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: { email: "", policy: false },
    mode: "all",
  });

  const [registration, { isLoading }] = useSimpleRegisterMutation();

  const goToSignIn = useCallback(() => changeTab("sign-in"), []);

  const onSubmit = useCallback(async ({ email, policy }) => {
    try {
      const response = await registration({
        email,
        policy,
      }).unwrap();

      if (typeof window.fbq === "function") {
        window.fbq("init", window.fbPid, {
          em: response?.email,
          fn: response?.firstName,
          ln: response?.lastName,
        });
        window.fbq("track", "CompleteRegistration");
        dispatch(setRegistration(true));
      }
    } catch (error) {
      if (error?.data?.error?.message === authErrorMessages.toManyAttempts) {
        dispatch(setNotification(error));
      } else if (
        error?.data?.error?.message === authErrorMessages.isRegistration
      ) {
        setError("email", {
          type: "custom",
          message: (
            <>
              The email has already been taken. Please{" "}
              <Link onClick={goToSignIn}>Sign In.</Link>
            </>
          ),
        });
      } else {
        setError("email", {
          type: "custom",
          message:
            error?.data?.error?.details?.email?.[0] ||
            error?.data?.error?.message,
        });
      }
    }
  }, []);

  useEffect(() => {
    dispatch(setNotification(""));
    const rawQuery = location.search;
    const emailMatch = rawQuery.match(/[?&]email=([^&]*)/);
    const email = emailMatch ? decodeURIComponent(emailMatch[1]) : null;

    if (email) {
      setValue("email", email);
      setValue("policy", true);
      handleSubmit(onSubmit)({ email, policy: true });
    }
  }, [location]);

  return (
    <Container onSubmit={handleSubmit(onSubmit)}>
      <AuthTitle
        title="Sign up"
        subTitle="Already have a Cart2Cart account?"
        titleLink="Sign In"
        goTo={goToSignIn}
      />

      <AuthInput
        error={errors?.email?.message}
        control={control}
        label="Email"
        name="email"
        rules={{
          required: InputsRules.required,
          pattern: InputsRules.patternEmail,
        }}
      />

      <AuthRegistrationFooter
        error={errors?.policy?.message}
        onSubmit={handleSubmit(onSubmit)}
        isValid
        isLoading={isLoading}
        control={control}
      />

      <AuthSocial title="Sign up" />

      <DisabledInput type="submit" />
    </Container>
  );
};

export default AuthRegistration;
